// extracted by mini-css-extract-plugin
module.exports = {"container":"_-_-pharmacy-src-question-questionCreatedWarning-questionCreatedWarning__container--12t1C"};